"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  fileAccept: {
    id: 'form.errors.fileAccept',
    defaultMessage: 'Invalid file {count, plural, one {type} other {types ({count})}}'
  },
  fileTooBig: {
    id: 'form.errors.fileTooBig',
    defaultMessage: '{count, plural, one {The file is} other {{count} files are}} too large (maximum size is {count, plural, one {{size}} other {{size} per file}})' // eslint-disable-line

  }
});

exports["default"] = _default;